/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function PurchaseIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="product">
        <g id="icon-game copy">
          <circle
            id="Oval"
            cx="78.5"
            cy="78.5"
            r="77.5"
            fill={mainColor}
            stroke="white"
            stroke-width="2"
          />
          <g id="shopping-cart 1">
            <g id="Group">
              <g id="Group_2">
                <g id="Group_3">
                  <path
                    id="Vector"
                    d="M114.778 44.7273H51.4545C51.2638 44.7273 51.0897 44.7991 50.911 44.8528L49.3545 39.7382C48.8596 38.1116 47.3593 37 45.659 37H37.9319C36.865 37 36 37.865 36 38.9319V42.7955C36 43.8624 36.865 44.7273 37.9319 44.7273H42.7973L54.8675 84.3918L50.3595 89.651C48.5778 91.7296 47.7755 94.5936 48.5955 97.2056C49.6443 100.546 52.5926 102.682 55.9918 102.682H111.341C112.408 102.682 113.273 101.817 113.273 100.75V96.8863C113.273 95.8194 112.408 94.9544 111.341 94.9544H55.9916L62.1154 87.81C62.2694 87.6304 62.3826 87.4275 62.4994 87.2271H99.935C102.929 87.2271 105.654 85.4978 106.929 82.7886L120.41 54.1428C120.796 53.3184 121 52.4034 121 51.4959V50.9488C121 47.513 118.214 44.7273 114.778 44.7273Z"
                    fill={secondaryColor}
                  />
                  <path
                    id="Vector_2"
                    d="M59.1818 122C63.4495 122 66.9092 118.541 66.9092 114.273C66.9092 110.005 63.4495 106.546 59.1818 106.546C54.9141 106.546 51.4545 110.005 51.4545 114.273C51.4545 118.541 54.9141 122 59.1818 122Z"
                    fill={secondaryColor}
                  />
                  <path
                    id="Vector_3"
                    d="M105.546 122C109.813 122 113.273 118.541 113.273 114.273C113.273 110.005 109.813 106.546 105.546 106.546C101.278 106.546 97.8182 110.005 97.8182 114.273C97.8182 118.541 101.278 122 105.546 122Z"
                    fill={secondaryColor}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
PurchaseIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
PurchaseIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(PurchaseIcon);
memoized.displayName = 'PurchaseIcon';
export default memoized;
